module.exports = __webpack_public_path__ + "static/media/calendarsp.68def053.svg";